// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { recentQuotesStyles } from "@stoneage/Overrides/Widgets/Common/RecentQuotes";
import { xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";
import { viewAllLinkStyle } from "@stoneage/App/SharedStyles/link";

recentQuotesStyles.titleWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        margin-bottom: 16px;
        gap: 24px;
        ${xScreen("lte", "xs")} {
            gap: 10px;
            flex-wrap: wrap;
        }
    `,
};

recentQuotesStyles.tableWrapper = {
    css: css`
        width: 100%;
        overflow: auto;
    `,
};

recentQuotesStyles.titleLabel = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
        text-transform: capitalize;
    `,
};

recentQuotesStyles.viewAllLink = {
    ...viewAllLinkStyle,
};

recentQuotesStyles.dataTable = {
    css: css`
        table {
            width: 100%;
            table-layout: fixed;
        }

        ${xScreen("gt", "md")} {
            thead th:not(:last-child),
            tbody td:not(:last-child) {
                width: 12%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            /* Last column - Ship To Address */
            thead th:last-child,
            tbody td:last-child {
                width: 5%;
            }
        }
    `,
};
